module.exports = __webpack_public_path__ + "static/media/fancy-plants2.99f7de41.png";